var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useIndicatorLayouts } from '../context/indicator-layouts-context';
import { IndicatorLayoutValueFirst } from '../indicator-layouts';
import { indicatorHasValue } from '../utils/indicator-has-value';
var cls = classNames('indicator-group-layout-panel-list');
var IndicatorGroupLayoutPanelListDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding: ", " 0;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding: ", " 0;\n  "])), theme.UNIT(4), theme.UNIT(4))
});
var PanelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TextValueStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 1.7em;\n  "], ["\n    font-size: 1.7em;\n  "])))
});
var IndicatorPanelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'IndicatorGroupLayoutPanelList',
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var IndicatorGroupLayoutPanelList = function (props) {
  var componentProps = useComponentProps(My.NAME, IndicatorGroupLayoutPanelListDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity;
  var indicatorLayouts = useIndicatorLayouts();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, entity.indicators.map(function (indicator, index) {
    var _a;
    var Layout = indicatorLayouts[(_a = indicator.layout) === null || _a === void 0 ? void 0 : _a.component] || IndicatorLayoutValueFirst;
    if (indicatorHasValue(indicator)) {
      return React.createElement(Layout, {
        key: index,
        entity: indicator
      });
    }
    return null;
  }));
};
IndicatorGroupLayoutPanelList.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;